import { render, staticRenderFns } from "./downloadPage.vue?vue&type=template&id=3d5accea&"
import script from "./downloadPage.vue?vue&type=script&lang=ts&"
export * from "./downloadPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports